// 工单挂起操作
import { Modal, message as Message } from 'ant-design-vue'
import { hungupMsg, batchHungupMsg } from './config'
import { hungupOrder } from '@/api/workPlace/workOrder'
import { createVNode } from 'vue'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
export default function useHungup() {
  function handleHungup(params) {
    // suspendTag（0-取消挂起；1-健管挂起；2-自动挂起）
    const { batchFlag, callBack, ...query } = params
    const { suspendTag } = query
    const Config = batchFlag ? batchHungupMsg : hungupMsg
    Modal.confirm({
      title: Config[suspendTag].title,
      icon: () => createVNode(ExclamationCircleOutlined),
      content: Config[suspendTag].content,
      centered: true,
      onOk() {
        hungupOrder(query)
          .then(res => {
            const { result, title, message } = res
            if (result) {
              Message.success('操作成功')
              callBack && callBack()
            } else {
              overflow({ title, message })
            }
          })
          .catch(() => {
            //
          })
      },
      onCancel() {
        //
      }
    })
  }
  function overflow(param) {
    const { title, message } = param
    Modal.error({
      centered: true,
      title,
      content: message
    })
  }
  return {
    handleHungup
  }
}
